exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".college-manage-detail-container[data-v-31879790]{overflow:hidden}.up-box[data-v-31879790]{display:flex}.upload-bezel[data-v-31879790]{width:148px}.isUpload .el-upload--picture-card[data-v-31879790]{display:none}.el-radio-group[data-v-31879790]{display:flex}.is-signed-radio-group[data-v-31879790]{flex-direction:column;align-items:flex-start}.is-signed-radio-group .el-radio[data-v-31879790]{margin:6px 0}.is-signed-tip[data-v-31879790]{margin-left:12px;color:#e6a23c;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-31879790&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/CollegeManageDetail.vue
// module id = 485
// module chunks = 0